// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2_jcK","label":"Section_label__39pgq","contentWrap":"Section_contentWrap__2bK7Y","footer":"Section_footer__EWlZf","footerInner":"Section_footerInner__13sQL"};